import React, { useEffect, useRef, useState } from "react";
import Accountpagesidemenu from "../components/Accountpagesidemenu";
import Accountpagecontent from "../components/Accountpagecontent";
import { getalluseraddressess } from "../redux/action/orderAction";
import { useDispatch, useSelector } from "react-redux";

import {
  getPersionalData,
  getAllOrders,
  getPersionalAddress,
  getRedeemPointsDetails,
  getShoppingDetails,
  getSingleOrder,
  getWishList,
  logoutWebsite,
  removeaddress,
} from "../redux/action/myAccountAction";
import { logout } from "../redux/action/authAction";
import { accountMenu } from "../utilities/helper";
import constants from "../utilities/constants";
import PopupModal from "../components/PopupModal";
import Accountpagemodal from "./Modalscreens/Accountpagemodal";
import { getAuthModalType, loginModalAction } from "../redux/action/authAction";
import { useNavigate } from "react-router-dom";
import { Toast } from "../components/Atoms/Toast";
import { clearvoucherdata } from "../redux/action/cartAction";
import { Link } from "react-router-dom";
import config from "../utilities/config";
export default function Account() {
  const dispatch = useDispatch();
  const { accessToken, userProfile_id, userProfile_email, isLoggedIn } =
    useSelector((state) => state.authReducer);
  const {
    userAddressess_success,
    USER_ADDRESSES_FAILURE,
    USER_ADDRESSES_REQUEST,
  } = useSelector((state) => state.useraddressreducer);
  const [myAccountPageHeader, setMyAccountPageHeader] = useState(
    accountMenu[0]
  );

  const [isOpen, setIsOpen] = useState(false);
  const [modelTitle, setModeltitle] = useState(null);
  const [modelSubTitle, setModelSubTitle] = useState(null);
  const [showModelData, setShowModelData] = useState(null);
  const [headerEditModal, setHeaderEditModal] = useState(false);
  const [value, setvalue] = useState(null);
  const [editManageAddressData, setEditManageAddressData] = useState(null);
  const [editaddressid, seteditaddressid] = useState(null);
  const navigation = useNavigate();
  const ref = useRef(null);
  const {
    //persionalinformation
    persionalInformationDataLoading,
    persionalInformationDataSuccess,
    persionalInformationDataError,
    //address
    persionalAddressDataLoading,
    persionalAddressDataSuccess,
    persionalAddressDataError,
    //wishlist
    wishListDataLoading,
    wishListDataSuccess,
    wishListDataError,
    //all orders
    allOrdersDataLoading,
    allOrdersDataSuccess,
    allOrdersDataError,
    //single order
    singleOrderDataLoading,
    singleOrderDataSuccess,
    singleOrderDataError,
  } = useSelector((state) => state.myAccountReducer);

  const handleNavigation = (title) => {
    if (title === "addresses") {
      dispatch(getalluseraddressess(userProfile_id));
    }
    const formattedTitle = title.toLowerCase().replace(/\s+/g, "");
    navigation(constants.ADDITIONAL_PATH + `/account-${formattedTitle}`);
  };
  useEffect(() => {
    config.logGeneral && console.log(
      "getAccountpath",
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ]
    );

    // if (!ref.current) {
    // Account_page_Ref.current = true;
    // ref.current = true;
    if (
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ] === constants.Account_Wishlist
    ) {
      // config.logGeneral && console.log("windows1");

      // config.logGeneral && console.log("constantlowercase", constants.Wishlist.toLowerCase());
      handleNavigation("wishlist");

      setMyAccountPageHeader(accountMenu[3]);
    } else if (
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ] === constants.Account_Profile
    ) {
      // config.logGeneral && console.log("windows2");
      setMyAccountPageHeader(accountMenu[0]);
      handleNavigation("profile");
    } else if (
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ] === constants.Account_Addresses
    ) {
      setMyAccountPageHeader(accountMenu[1]);
      handleNavigation("addresses");
    } else if (
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ] === constants.Account_Allorders
    ) {
      // config.logGeneral && console.log("windows2");
      setMyAccountPageHeader(accountMenu[4]);
      handleNavigation(constants.AllOrders);
    } else if (
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ] === constants.Account_Allorders
    ) {
      // config.logGeneral && console.log("windows2");
      setMyAccountPageHeader(accountMenu[4]);
      handleNavigation(constants.AllOrders);
    } else if (
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ] === constants.Account_Redeempoints
    ) {
      // config.logGeneral && console.log("windows2");
      setMyAccountPageHeader(accountMenu[5]);
      handleNavigation(constants.RedeemPoints);
    }
    // else if (
    //   window.location.pathname.split("/")[2] === constants.Resetpassword
    // ) {
    //   alert("resetpasswor")
    //   config.logGeneral && console.log("resetpassword called!")
    //   setTimeout(() => {
    //     dispatch(getAuthModalType(constants.Reset))
    //   }, 1000);

    // }
    // }
    config.logGeneral && console.log(
      window.location.pathname.split("/")[1],
      "resetpassword called!"
    );
  }, [window.location.pathname]);
  config.logGeneral && console.log(
    "myAccountPageHeader",
    myAccountPageHeader.title === constants.PersonalInformation
  );
  config.logGeneral && console.log("persionalAddressDataSuccess12", persionalAddressDataSuccess);

  // useEffect(() => {
  //   if (
  //     window.location.pathname.split("/")[
  //       window.location.pathname.split("/").length - 1
  //     ] === constants.Account_Profile
  //   ) {
  //     ref.current = false;
  //   }
  // }, [window.location.pathname]);

  // Signin: "signin",
  // SigninOtp: "signinotp",
  // Register: "register",
  // Login: "login",
  // Reset: "reset",
  // Subscribe: "subscribe",
  useEffect(() => {
    config.logGeneral && console.log(userProfile_id, "userProfile_id in account ");
    config.logGeneral && console.log(
      window.location.pathname.split("/")[2],
      "window.location.pathname.split(" / ")[2]"
    );
    config.logGeneral && console.log(constants.Resetpassword, "constants.Resetpassword");

    if (
      window.location.pathname.split("/")[2] === constants.Resetpassword &&
      (userProfile_id === null || !userProfile_id)
    ) {
      dispatch(getAuthModalType(constants.Reset));
      return;
    } else if (userProfile_id === null || !userProfile_id) {
      dispatch(getAuthModalType(constants.Login));
      // dispatch(loginModalAction({ isOpenModal: true, modalType: 'cart' }));
    } else {
      dispatch(getPersionalData(userProfile_id));
      if (myAccountPageHeader.title === constants.PersonalInformation) {
        // handleNavigation("profile");
        // ref.current = false;
      } else if (myAccountPageHeader.title === constants.ManageAddress) {
        handleNavigation("addresses");
      } else if (myAccountPageHeader.title === constants.Wishlist) {
        handleNavigation("wishlist");
      } else if (myAccountPageHeader.title === constants.AllOrders) {
        handleNavigation(constants.AllOrders);
      } else if (myAccountPageHeader.title === constants.SingleOrder) {
        handleNavigation(constants.SingleOrder);
      } else if (myAccountPageHeader.title === constants.RedeemPoints) {
        handleNavigation(constants.RedeemPoints);
      }
    }
  }, [myAccountPageHeader, userProfile_id]);
  // handle the model values
  const handleModelChange = (value, handleModal, handlevalue = null) => {
    setHeaderEditModal(handleModal); // model headers are handle by this and also model datas are displayed by this condition
    if (value === constants.Wishlist) {
      setIsOpen(false);
      navigation(
        constants.ADDITIONAL_PATH +
          "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
      );
    } else {
      setIsOpen(true);
    }
    setShowModelData(value);
    if (value === constants.MobileNumber) {
      setModeltitle("Change Mobile Number");
      setModelSubTitle(null);
    }
    if (value === constants.EmailAddress) {
      setModeltitle("Change Email Address");
      setModelSubTitle(null);
    }
    if (value === constants.Password) {
      setModeltitle("Reset your Password");
      setModelSubTitle("Create a new password to secure your account.");
    }
    if (value === constants.PersonalInformation) {
      setModeltitle(value); //edit personal information
      setModelSubTitle(null);
    }
    if (value === constants.AddressDelete) {
      seteditaddressid(handlevalue);
      setModeltitle("Confirmation");
      setModelSubTitle(null);
    }
    if (value === constants.AddressEdit) {
      setModeltitle("Edit Address");
      setModelSubTitle(null);
      setEditManageAddressData(handlevalue);
    }
    if (value === constants.ManageAddress) {
      setModeltitle("Add Address");
      setModelSubTitle(null);
    }
    if (value === constants.SingleOrder) {
      setModeltitle("View Orders");
      setModelSubTitle(null);
    }

    // if (value === constants.Logout) {
    //   setModeltitle(null);
    //   setModelSubTitle(null);
    // }
  };
  // handle model input changes
  const handleInputChange = (label, value) => {
    setvalue(value);
    config.logGeneral && console.log("handleChangedata", label, value);
    // if (label === "Make this as a Primary Address") {
    //   setvalue(!value);
    // } else {
    //   setvalue(value);
    // }
  };
  // handle model button changes
  const handleButtonChange = (label) => {
    config.logGeneral && console.log(label, "labelnnn");
    if (label === "Cancel") {
      setIsOpen(false);
    }
    if (label === "Remove") {
      config.logGeneral && console.log("Removeclicked");
      setShowModelData(constants.RemoveWishlist);
      setModeltitle("Confirmation");
      setModelSubTitle(null);
      setIsOpen(true);
      setHeaderEditModal(constants.Confirmation); //using this handle the conformation models and close icon
    }
    if (label === "log out confirm") {
      dispatch(logout());
      dispatch(logoutWebsite());
      dispatch(clearvoucherdata());
      setIsOpen(false);
    }
    if (label === "Confirm") {
      dispatch(removeaddress(editaddressid));
      dispatch(getPersionalData(userProfile_id));
    }
  };
  //handle side menu click and show content
  const handleClick = (item) => {
    config.logGeneral && console.log("handleClickitem", item);
    userProfile_id ?? dispatch(getPersionalData(userProfile_id));
    setMyAccountPageHeader(item);
    // Toast("Mobile number is invalid.", "success");

    if (item.title === constants.PersonalInformation) {
      //   dispatch(getPersionalData());
      handleNavigation("profile");
    }
    // if (item.title === constants.ManageAddress) {
    //   dispatch(getPersionalAddress());
    // }
    if (item.title === constants.ShoppingBag) {
      navigation(constants.ADDITIONAL_PATH + "/cart");
    }

    // if (item.title === constants.Wishlist) {
    //   dispatch(getWishList());
    // }
    // if (item.title === constants.AllOrders) {
    //   dispatch(getAllOrders());
    // }
    if (item.title === constants.RedeemPoints) {
      dispatch(getRedeemPointsDetails());
    }

    if (item.title === constants.Logout) {
      // dispatch(logoutWebsite());
      setModeltitle("Confirmation");
      setModelSubTitle(null);
      setIsOpen(true);
      setShowModelData(constants.Logout);
      setHeaderEditModal(constants.Confirmation);
      setMyAccountPageHeader(accountMenu[0]);
      handleNavigation("profile");
    }
    if (item.title === constants.SingleOrder) {
      dispatch(getSingleOrder(item.orderId));
    }
  };

  return (
    <main className="mx-auto container mt-2 mb-10 h-full lg:p-0">
      <h1 className="font-bold text-[34px] font-tiemann ps-2">
        My Account
      </h1>
 <Link to={constants.ADDITIONAL_PATH + "/contactus"}>
          <button className="flex bg-white fixed bottom-1/2 transform rotate-[270deg] lg:-left-14 -left-12 rounded-bl-2xl rounded-br-2xl lg:py-2 lg:px-4 py-2 px-3 text-[#020307] font-tiemann font-bold lg:text-xl text-base shadow-md z-10">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="transform rotate-[90deg] pt-1"
            >
              <path
                d="M14.8063 1.4124C14.0725 1.88413 13.3649 2.35585 12.6311 2.82758C12.4739 2.9324 12.3691 2.9324 12.2118 2.82758C11.5042 2.35585 10.7967 1.91034 10.0891 1.43861C9.25045 0.888265 8.43803 1.17654 8.09734 2.11999C7.80906 2.9062 7.49458 3.6924 7.20631 4.47861C7.15389 4.63585 7.04906 4.71447 6.86562 4.71447C6.00079 4.74068 5.13596 4.79309 4.29734 4.84551C3.3801 4.89792 2.85596 5.6055 3.09182 6.49654C3.30148 7.33516 3.53734 8.17378 3.7732 8.98619C3.82562 9.16964 3.7732 9.27447 3.64217 9.40551C2.96079 9.92964 2.30561 10.48 1.65044 11.0041C0.916649 11.5807 0.916649 12.4717 1.65044 13.0745C2.30561 13.5986 2.96079 14.149 3.61596 14.6469C3.79941 14.7779 3.82562 14.909 3.7732 15.1186C3.53734 15.931 3.32769 16.7434 3.17044 17.32C2.90837 18.4469 3.35389 19.1283 4.29734 19.1807C5.16217 19.2331 6.027 19.2855 6.91803 19.3117C7.10148 19.3117 7.1801 19.3903 7.25872 19.5476C7.5732 20.36 7.88768 21.1724 8.20217 21.9848C8.54286 22.8234 9.35527 23.0855 10.1153 22.5876C10.8491 22.1158 11.5567 21.6441 12.2904 21.1724C12.4477 21.0676 12.5525 21.0676 12.736 21.1724C13.4698 21.6703 14.2036 22.1421 14.9635 22.6138C15.6711 23.0593 16.5098 22.771 16.8242 21.9848C17.1387 21.1724 17.4532 20.3338 17.7677 19.5214C17.8201 19.3379 17.9249 19.2855 18.1084 19.2855C18.947 19.2593 19.7594 19.1545 20.598 19.1545C21.4367 19.1545 22.1967 18.4207 21.8822 17.3986C21.6201 16.5862 21.4366 15.7738 21.2008 14.9614C21.1484 14.8041 21.1746 14.6993 21.3318 14.5945C22.0132 14.0441 22.6684 13.52 23.3498 12.9697C24.0835 12.3669 24.0835 11.5021 23.3498 10.9255C22.6684 10.3752 22.0132 9.85103 21.3318 9.30069C21.2008 9.19586 21.1484 9.11724 21.2008 8.93379C21.4366 8.09517 21.6463 7.25655 21.8822 6.41793C22.118 5.5531 21.5939 4.81931 20.7029 4.7931C19.838 4.74069 18.9732 4.68828 18.0822 4.66207C17.8725 4.66207 17.7939 4.55724 17.7415 4.4C17.4532 3.61379 17.1387 2.80138 16.8242 2.01517C16.4049 1.17654 15.5663 0.914472 14.8063 1.4124ZM10.5084 7.67585L15.7498 12.9172C15.8808 13.0483 15.9856 13.2317 16.0118 13.4152C16.0118 13.4676 16.038 13.5462 16.038 13.5986C16.038 13.8345 15.9332 14.0965 15.7498 14.28L13.6008 16.429C13.2339 16.7958 12.6311 16.7958 12.2642 16.429C11.8973 16.0621 11.8973 15.4593 12.2642 15.0924L13.7318 13.6248L9.17182 9.06481C8.80493 8.69792 8.80493 8.09516 9.17182 7.72826C9.53872 7.30895 10.1415 7.30895 10.5084 7.67585Z"
                fill="#15AB9E"
              />
            </svg>
            Get Enquiry
          </button>
        </Link>
      <section className="md:flex gap-5 mt-5 mx-auto container">
        
          <Accountpagesidemenu
            handleClick={handleClick}
            activeSidebar={myAccountPageHeader}
            isLoggedIn={isLoggedIn}
          />
        
        <div className={`md:w-4/5 w-11/12 mx-auto border border-[#D9D9D9] rounded-tl-[16px] rounded-tr-[16px] lg:m-0`}>
          {myAccountPageHeader?.title !== constants.Logout && (
            <Accountpagecontent
              header={myAccountPageHeader}
              handleModel={handleModelChange}
              handleButtonChange={handleButtonChange}
              handleClick={handleClick}
            />
          )}
          <div className="overflow-hidden">
          <PopupModal isOpen={isOpen} page="Accountpagemodal">
            <Accountpagemodal
              modelTitle={modelTitle}
              modelSubTitle={modelSubTitle}
              handleInputChange={handleInputChange}
              handleButtonChange={handleButtonChange}
              showModelData={showModelData}
              headerEditModal={headerEditModal}
              value={value}
              setIsOpen={setIsOpen}
              personalval={
                userProfile_id && persionalInformationDataSuccess
                  ? persionalInformationDataSuccess
                  : null
              }
              editManageAddressData={editManageAddressData}
            />
          </PopupModal>
          </div>
        </div>
      </section>
    </main>
  );
}
